import { render, staticRenderFns } from "./studyProgress.vue?vue&type=template&id=33be8540&scoped=true&"
import script from "./studyProgress.vue?vue&type=script&lang=js&"
export * from "./studyProgress.vue?vue&type=script&lang=js&"
import style0 from "./studyProgress.vue?vue&type=style&index=0&id=33be8540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33be8540",
  null
  
)

export default component.exports